
import { shapeFaireDistanceUnitForApp, shapeFaireMassUnitForApp, shapeKeyDate } from '@/utils/product/shapeAttributes';
import { replaceOperation } from '@/utils/product/operations';
import { editInventory } from '@/utils/edit/inventory';
import { toString } from '@/utils/number';
import { getSize } from '@/utils/iterable/getSize';

import { AMOUNT, OPERATIONS, PRICE_API_KEY_TO_ATTRIBUTE_CURRENCY_MAP, VALUE } from '@/constants/product';
import { EBAY, ETSY, FAIRE, SHOPIFY } from '@/constants/channels';
import { ATTRIBUTE } from '@/constants/attributes';
import { EMPTY } from '@/constants';
import { FORM } from '@/constants/forms';

export function inventory({ operation, product, ...rest }) {
  const channel = product.get('channel');
  const operationType = operation.get('type');

  switch (channel) {
    case EBAY: {
      switch (operationType) {
        case OPERATIONS[EBAY].PRICE: {
          const { shopData, userFeatures } = rest;
          const value = operation.getIn(['value', 'value']);
          const updates = editInventory({ product, shopData, userFeatures, [ATTRIBUTE.PRICE]: value });

          return {
            ...rest,
            product: updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[EBAY].QUANTITY: {
          const { shopData, userFeatures } = rest;
          const value = operation.get('value');
          const updates = editInventory({ product, shopData, userFeatures, [ATTRIBUTE.QUANTITY]: value });

          return {
            ...rest,
            product: updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[EBAY].SKU: {
          const { shopData, userFeatures } = rest;
          const value = operation.get('value');
          const updates = editInventory({ product, shopData, userFeatures, [ATTRIBUTE.SKU]: value });

          return {
            ...rest,
            product: updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        default: {
          return { product, ...rest };
        }
      }
    }

    case ETSY: {
      switch (operationType) {
        case OPERATIONS[ETSY].PRICE: {
          const { shopData, userFeatures } = rest;
          const value = operation.getIn(['value', 0, 'value', 'value']);
          const updates = editInventory({ product, shopData, userFeatures, [ATTRIBUTE.PRICE]: value });

          return {
            ...rest,
            product: updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[ETSY].QUANTITY: {
          const { shopData, userFeatures } = rest;
          const value = operation.getIn(['value', 0, 'value']);
          const updates = editInventory({ product, shopData, userFeatures, [ATTRIBUTE.QUANTITY]: value });

          return {
            ...rest,
            product: updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[ETSY].SKU: {
          const { shopData, userFeatures } = rest;
          const value = operation.getIn(['value', 0, 'value']);
          const updates = editInventory({ product, shopData, userFeatures, [ATTRIBUTE.SKU]: value });

          return {
            ...rest,
            product: updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        default: {
          return { product, ...rest };
        }
      }
    }

    case FAIRE: {
      switch (operationType) {
        case OPERATIONS[FAIRE].CONTINUE_SELLING: {
          const { shopData, userFeatures } = rest;
          const value = operation.get('value');
          const updates = editInventory({ product, shopData, userFeatures, [ATTRIBUTE.CONTINUE_SELLING]: value });

          return {
            ...rest,
            product: updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[FAIRE].DEADLINE_DATE: {
          const { shopData, userFeatures } = rest;
          const value = operation.get('value');
          const updates = editInventory({ product, shopData, userFeatures, [ATTRIBUTE.PREORDER]: shapeKeyDate(value) });

          return {
            ...rest,
            product: updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[FAIRE].DISTANCE_UNIT: {
          const { shopData, userFeatures } = rest;
          const value = operation.get('value');
          const updates = editInventory({
            product,
            shopData,
            userFeatures,
            [ATTRIBUTE.DISTANCE_UNIT]: shapeFaireDistanceUnitForApp(value),
          });

          return {
            ...rest,
            product: updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[FAIRE].END_DATE: {
          const { shopData, userFeatures } = rest;
          const value = operation.get('value');
          const updates = editInventory({ product, shopData, userFeatures, [ATTRIBUTE.PREORDER]: shapeKeyDate(value) });

          return {
            ...rest,
            product: updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[FAIRE].GTIN: {
          const { shopData, userFeatures } = rest;
          const value = operation.get('value');
          const updates = editInventory({ product, shopData, userFeatures, [ATTRIBUTE.GTIN]: value || '' });

          return {
            ...rest,
            product: updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[FAIRE].HEIGHT: {
          const { shopData, userFeatures } = rest;
          const value = operation.get('value');
          const updates = editInventory({ product, shopData, userFeatures, [ATTRIBUTE.HEIGHT]: toString(value) });

          return {
            ...rest,
            product: updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[FAIRE].KEEP_ACTIVE: {
          const { shopData, userFeatures } = rest;
          const value = operation.get('value');
          const updates = editInventory({ product, shopData, userFeatures, [ATTRIBUTE.KEEP_ACTIVE]: value });

          return {
            ...rest,
            product: updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[FAIRE].LENGTH: {
          const { shopData, userFeatures } = rest;
          const value = operation.get('value');
          const updates = editInventory({ product, shopData, userFeatures, [ATTRIBUTE.LENGTH]: toString(value) });

          return {
            ...rest,
            product: updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[FAIRE].MASS_UNIT: {
          const { shopData, userFeatures } = rest;
          const value = operation.get('value');
          const updates = editInventory({
            product,
            shopData,
            userFeatures,
            [ATTRIBUTE.MASS_UNIT]: shapeFaireMassUnitForApp(value),
          });

          return {
            ...rest,
            product: updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[FAIRE].PREORDER: {
          const { shopData, userFeatures } = rest;
          const value = operation.get('value');
          const updates = editInventory({ product, shopData, userFeatures, [ATTRIBUTE.PREORDER]: value });

          return {
            ...rest,
            product: updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[FAIRE].QUANTITY: {
          const { shopData, userFeatures } = rest;
          const value = operation.get('value');
          const updates = editInventory({ product, shopData, userFeatures, [ATTRIBUTE.QUANTITY]: toString(value) });

          return {
            ...rest,
            product: updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[FAIRE].RESTOCK_DATE: {
          const { shopData, userFeatures } = rest;
          const value = operation.get('value') || null;

          if (value !== null && product.getIn([FORM.INVENTORY, ATTRIBUTE.QUANTITY, VALUE]) !== AMOUNT.ZERO) {
            return { ...rest, product };
          }

          const updates = editInventory({
            product,
            shopData,
            userFeatures,
            [ATTRIBUTE.RESTOCK_DATE]: value && new Date(value),
          });

          return {
            ...rest,
            product: updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[FAIRE].PRICES: {
          const { shopData, userFeatures } = rest;
          const payload = {};

          for (const [key, values] of operation.get('value').entries()) {
            if (!PRICE_API_KEY_TO_ATTRIBUTE_CURRENCY_MAP.hasOwnProperty(key)) continue;

            const { attribute, currency } = PRICE_API_KEY_TO_ATTRIBUTE_CURRENCY_MAP[key];

            if (!payload[attribute]) {
              payload[attribute] = {};
            }

            payload[attribute][currency] = values.get('value') || '';
          }

          if (getSize(payload) === 0) {
            return { product, ...rest };
          }

          const updates = editInventory({ product, shopData, userFeatures, ...payload });

          return {
            ...rest,
            product: updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[FAIRE].SKU: {
          const { shopData, userFeatures } = rest;
          const value = operation.get('value');
          const updates = editInventory({ product, shopData, userFeatures, [ATTRIBUTE.SKU]: value || '' });

          return {
            ...rest,
            product: updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[FAIRE].START_DATE: {
          const { shopData, userFeatures } = rest;
          const value = operation.get('value');
          const updates = editInventory({ product, shopData, userFeatures, [ATTRIBUTE.PREORDER]: shapeKeyDate(value) });

          return {
            ...rest,
            product: updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[FAIRE].TARIFF_CODE: {
          const { shopData, userFeatures } = rest;
          const value = operation.get('value');
          const updates = editInventory({ product, shopData, userFeatures, [ATTRIBUTE.TARIFF_CODE]: value || '' });

          return {
            ...rest,
            product: updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[FAIRE].WEIGHT: {
          const { shopData, userFeatures } = rest;
          const value = operation.get('value');
          const updates = editInventory({ product, shopData, userFeatures, [ATTRIBUTE.WEIGHT]: toString(value) });

          return {
            ...rest,
            product: updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[FAIRE].WIDTH: {
          const { shopData, userFeatures } = rest;
          const value = operation.get('value');
          const updates = editInventory({ product, shopData, userFeatures, [ATTRIBUTE.WIDTH]: toString(value) });

          return {
            ...rest,
            product: updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        default: {
          return { product, ...rest };
        }
      }
    }

    case SHOPIFY: {
      switch (operationType) {
        case OPERATIONS[SHOPIFY].BARCODE: {
          const { shopData, userFeatures } = rest;
          const value = operation.getIn(['value', 0, 'value']);
          const updates = editInventory({ product, shopData, userFeatures, [ATTRIBUTE.BARCODE]: value });

          return {
            ...rest,
            product: updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[SHOPIFY].CAP: {
          const { shopData, userFeatures } = rest;
          const value = operation.getIn(['value', 0, 'value', 'value']);
          const updates = editInventory({ product, shopData, userFeatures, [ATTRIBUTE.CAP]: value });

          return {
            ...rest,
            product: updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[SHOPIFY].CHARGE_TAX: {
          const { shopData, userFeatures } = rest;
          const value = operation.getIn(['value', 0, 'value', 'taxable']);
          const updates = editInventory({ product, shopData, userFeatures, [ATTRIBUTE.CHARGE_TAX]: !!value });

          return {
            ...rest,
            product: updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[SHOPIFY].CONTINUE_SELLING: {
          const { shopData, userFeatures } = rest;
          const value = operation.getIn(['value', 0, 'value', 'inventoryPolicy']);
          const updates = editInventory({ product, shopData, userFeatures, [ATTRIBUTE.CONTINUE_SELLING]: value === 'continue' });

          return {
            ...rest,
            product: updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[SHOPIFY].COUNTRY_CODE: {
          const { shopData, userFeatures } = rest;
          const value = operation.getIn(['value', 0, 'value', 'countryCode']);
          const updates = editInventory({ product, shopData, userFeatures, [ATTRIBUTE.COUNTRY_CODE]: value });

          return {
            ...rest,
            product: updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[SHOPIFY].CPI: {
          const { shopData, userFeatures } = rest;
          const value = operation.getIn(['value', 0, 'value', 'value']);
          const updates = editInventory({ product, shopData, userFeatures, [ATTRIBUTE.CPI]: value });

          return {
            ...rest,
            product: updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[SHOPIFY].HS_CODE: {
          const { shopData, userFeatures } = rest;
          const value = operation.getIn(['value', 0, 'value', 'hsCode']);
          const updates = editInventory({ product, shopData, userFeatures, [ATTRIBUTE.HS_CODE]: value });

          return {
            ...rest,
            product: updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[SHOPIFY].PHYSICAL: {
          const { shopData, userFeatures } = rest;
          const value = operation.getIn(['value', 0, 'value', 'requiresShipping']);
          const updates = editInventory({ product, shopData, userFeatures, [ATTRIBUTE.PHYSICAL]: !!value });

          return {
            ...rest,
            product: updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[SHOPIFY].PRICE: {
          const { shopData, userFeatures } = rest;
          const value = operation.getIn(['value', 0, 'value', 'value']);
          const updates = editInventory({ product, shopData, userFeatures, [ATTRIBUTE.PRICE]: value });

          return {
            ...rest,
            product: updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[SHOPIFY].QUANTITY: {
          const { shopData, userFeatures } = rest;
          const value = operation.getIn(['value', 0, 'value']);
          const updates = editInventory({ product, shopData, userFeatures, [ATTRIBUTE.QUANTITY]: value });

          return {
            ...rest,
            product: updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[SHOPIFY].SKU: {
          const { shopData, userFeatures } = rest;
          const value = operation.getIn(['value', 0, 'value']);
          const updates = editInventory({ product, shopData, userFeatures, [ATTRIBUTE.SKU]: value });

          return {
            ...rest,
            product: updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[SHOPIFY].TRACK_QUANTITY: {
          const { shopData, userFeatures } = rest;
          const value = operation.getIn(['value', 0, 'value', 'inventoryManagement']);
          const updates = editInventory({
            product,
            shopData,
            userFeatures,
            [ATTRIBUTE.TRACK_QUANTITY]: value === SHOPIFY,
          });

          return {
            ...rest,
            product: updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[SHOPIFY].WEIGHT: {
          const { shopData, userFeatures } = rest;
          const weight = operation.getIn(['value', 0, 'value', 'weight']);
          const unit = operation.getIn(['value', 0, 'value', 'unit']);
          const updates = editInventory({
            product,
            shopData,
            userFeatures,
            [ATTRIBUTE.WEIGHT]: weight, [ATTRIBUTE.UNIT]: unit,
          });

          return {
            ...rest,
            product: updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        default: {
          return { product, ...rest };
        }
      }
    }

    default: {
      return { product, ...rest };
    }
  }
}
